import { Search,AccountHeadDetails } from './../../shared/user.model';
import { Component, OnInit } from '@angular/core';
import { DISABLED } from '@angular/forms/src/model';
import { Register } from '../../shared/user.model';
import { NgForm } from '@angular/forms';
//import { UserService } from '../../shared/user.service';
import { RegistrationService } from '../../registration.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import swal from 'sweetalert2';

@Component({
  selector: 'app-grievence-lodging',
  templateUrl: './grievence-lodging.component.html',
  styleUrls: ['./grievence-lodging.component.css']
})
export class GrievenceLodgingComponent implements OnInit {
  title ="Grievance Lodging";
  GrievancesLodging: any={};  
  UserName: string;
  RoleName: string;
  fileToUpload: File;
  formInvalid: boolean;
  fileNotUploaded:boolean;
  mode: any;
  Id: any;  
  userlist: any=[];
  GrievanceAlertDetails: any=[];
  constructor(private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler,private userService: RegistrationService) {
    
   }

  ngOnInit() {
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.GrievancesLodging.SainikUserName=this.UserName;}
    // this.route.params.subscribe(params => {      
    //   this.mode = params['mode'];
    //   this.Id = params['Id'];
    // });
    
    //From URL
    this.mode=localStorage.getItem('mode');
    this.Id = localStorage.getItem('grievanceId');
    localStorage.removeItem('grievanceId'); 
    localStorage.removeItem('mode');
    
    if (this.mode=='view')
    {
      this.title="View Grievance";
      this.GetGrievanceById(this.Id);
    }

    this.GetAllUsersForGrievance();
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.GetBasicDetailsOfSainik(this.UserName);
    }
    
  }


  GetBasicDetailsOfSainik(serviceNo){
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getBasicDetailsOfSainik(serviceNo)
      .subscribe(
        (data) => {
          this.GrievancesLodging = data;          
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  GetGrievanceById(Id:number)
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.userService.getGrievanceById(this.Id)
      .subscribe(
        (data) => {
          this.GrievancesLodging = data; 
          this.GrievanceAlertDetails=this.GrievancesLodging.GrievanceAlertDetails;         
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
  }
  UploadScanDocument(file: FileList) {
    let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdf)$/;
    let s: any = file.item(0).size / 1024;
    let size: any = parseFloat(s).toFixed(2);
    let uploadedFilename = file.item(0).name;
    let redexe = /^([a-zA-Z0-9\s_\\.\-:])+(.exe)$/;
    if (uploadedFilename.match(redexe)){
      swal('Warning!', "File type .exe is not allowed", 'warning');
      this.GrievancesLodging.ScanDocument="";
      return true;
    }
    if (uploadedFilename.match(regex) && (size <= 2048)) {
      this.fileToUpload = file.item(0);
      var reader = new FileReader();
      reader.onload = (event: any) => {
      
      }
      reader.readAsDataURL(this.fileToUpload);
      const data = new FormData();
      data.append("UploadedImage", file.item(0));
      let x = this.userService.uploadImage(data);
      x.subscribe(
        (response) => {  
          this.fileNotUploaded= false;
        }, (error) => {
          let i:any=document.getElementById('ScanDocument');
          i.value="";
          if (error.status == 400) {
            this.fileNotUploaded = true;
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
    else {
      let i: any = document.getElementById('ScanDocument');
      i.value = "";
      if (!uploadedFilename.match(regex))
        swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
      else if (size > 2048)
        swal('Warning!', "Please upload image file less than 2mb", 'warning');
    }
    
  }
  AddGrievances(form:NgForm)
  {
    
    if (!form.invalid)
    {
      console.log("data :" +JSON.stringify(this.GrievancesLodging))
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.AddSainikGrievances(this.GrievancesLodging).subscribe((response)=>{
        document.getElementById('loader-spinner').style.display = "none";
        //swal("Success!","Grievance Added Successfully");
        let grievanceNo=response;
        //swal("Success!","Grievance NO: grievanceNo'Successfully Forwarded To Higher Officer.",'success');

        swal("Success!", "Grievance NO. :" + grievanceNo + " has been succesfully forwarded to higher officer", "success")
        this.router.navigate(['/home/gl']);
      }, (error) => {
        if (error.status == 400) {
          swal('Warning!', "Sainik doesnot belongs to this district", 'warning');
        }
        document.getElementById('loader-spinner').style.display="none";
        this.errorHandler.HandlerError(error);
        
       
      }); 
    }       
      else
      {
        document.getElementById('loader-spinner').style.display = "none";
        this.formInvalid = true;
        var scanDocument = <HTMLInputElement>document.getElementById("ScanDocument");
        if (scanDocument.value == "")
        {
          this.fileNotUploaded = true;
        }
      }
    }


    GetAllUsersForGrievance()
    {
      document.getElementById('loader-spinner').style.display = "block";
      this.userService.getAllUsersForGrievance()
        .subscribe(
          (data) => {
            this.userlist = data;
            //swal("warning",this.sainikSchemeApplicationModel.ID);
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            this.errorHandler.HandlerError(error);
        });
    }
    cancel()
    {
      this.GrievancesLodging.ForwardToUserId='',
      this.GrievancesLodging.ActionStatus='',
      this.GrievancesLodging.status='',
      this.GrievancesLodging.ActionTaken=''
      // this.GrievancesLodging.ActionTaken='',
      // this.GrievancesLodging.ActionTaken='',
      // this.GrievancesLodging.ActionTaken='',
      // this.GrievancesLodging.ActionTaken='',
    }
    
}



// WEBPACK FOOTER //
// ./src/app/grievence-lodging/grievence-lodging/grievence-lodging.component.ts